import { render } from "./single.vue?vue&type=template&id=7becb76e&scoped=true&ts=true"
import script from "./single.vue?vue&type=script&setup=true&lang=ts"
export * from "./single.vue?vue&type=script&setup=true&lang=ts"

import "./style/single-page.less?vue&type=style&index=0&id=7becb76e&scoped=true&lang=less"
import "./style/pagination.less?vue&type=style&index=1&id=7becb76e&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7becb76e"],['__file',"src/views/browse-view/single.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7becb76e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7becb76e', __exports__)) {
    console.log('reload')
    api.reload('7becb76e', __exports__)
  }
  
  module.hot.accept("./single.vue?vue&type=template&id=7becb76e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('7becb76e', render)
  })

}


export default __exports__